import { PERMISSION } from '@/constants/permission.constant';

const vehicleList = () => import('@/views/vehicles/List.vue');
const vehicleAdd = () => import('@/views/vehicles/Add.vue');
const vehicleEdit = () => import('@/views/vehicles/Edit.vue');

export const vehicleRoute = [
  {
    path: '/vehicles',
    name: 'vehicle',
    component: vehicleList,
    meta: { requiresAuth: false, permissions: [PERMISSION.CAR_MANAGEMENT_READ] },
  },

  {
    path: '/vehicles/create',
    name: 'vehicle-create',
    component: vehicleAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.CAR_MANAGEMENT_CREATE] },
  },
  {
    path: '/vehicles/:id/edit',
    name: 'vehicle-edit',
    component: vehicleEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.CAR_MANAGEMENT_UPDATE] },
  },
];
